import { useContext } from "react";
import { battleTeamContext } from "./BattleTeamProvider";

export const useBattleTeam = () => {
    return useContext(battleTeamContext);
};
